export const LEAD_STATUSES = ["new", "contacted", "scheduled", "in_progress", "won", "lost"];

export const STATUS_LABELS = {
  new: "New",
  contacted: "Contacted",
  scheduled: "Scheduled",
  in_progress: "In Progress",
  won: "Won",
  lost: "Lost",
};

export const STATUS_CLASSES = {
  new: "bg-[rgba(202,255,26,0.12)] text-[#caff1a] border-[rgba(202,255,26,0.25)]",
  contacted: "bg-[rgba(255,204,102,0.12)] text-[#ffcc66] border-[rgba(255,204,102,0.25)]",
  scheduled: "bg-[rgba(125,184,255,0.12)] text-[#7db8ff] border-[rgba(125,184,255,0.25)]",
  in_progress: "bg-[rgba(255,255,255,0.08)] text-white/80 border-white/20",
  won: "bg-[rgba(120,255,180,0.12)] text-[#78ffb4] border-[rgba(120,255,180,0.25)]",
  lost: "bg-[rgba(255,120,120,0.10)] text-[#ff7878] border-[rgba(255,120,120,0.22)]",
};

export const ENTITY_TYPES = [
  "Independent Artist",
  "Band",
  "Musician / Session Player",
  "Singer-Songwriter",
  "DJ / Electronic Producer",
  "Record Label",
  "Recording Studio",
  "Music School / Academy",
  "Music Event Company",
  "Artist Management",
  "Music Venue",
  "Audio Equipment Brand",
  "Other",
];

export const SOURCES = ["website", "manual", "import"];

export const INTERACTION_TYPES = ["call", "email", "whatsapp", "meeting", "note"];
